export default "__VITE_ASSET__095f04b5__"